import React, { useRef, useState } from "react";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

import { useNavigate } from "react-router-dom";

import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";

import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import { FilterMatchMode } from "primereact/api";

export default function ProjectReportAndCMAReport() {

    const navigate = useNavigate();

    const ds = useRef(null);

    const [rows] = useState(20);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState("");

    // REPORT DATA
    const [reportData] = useState([
        {
            id: 1,
 
            unattended_leads: {
                numberOfLead: 7,
                projectReport: 7000,
            },	
            in_process:{
                numberOfLead: 7,
                projectReport: 7000,
            },
            call_not_pick_up: {
                numberOfLead: 7,
                projectReport: 7000,
            },
            not_interested:{
                numberOfLead: 7,
                projectReport: 7000,
            },
            work_assign_to_operation:{
                numberOfLead: 7,
                totalFeesAgreed: 1000,
                advanceRecd:800,
                finalDue:200, 
            },
            work_complete:{
                numberOfLead: 7,
                totalFeesAgreed: 1000,
                advanceRecd: 800,
                finalDue: 200,
            },
        },

        {
            id: 2,


            unattended_leads: {
                numberOfLead: 7,
                projectReport: 7000,
            },
            in_process: {
                numberOfLead: 7,
                projectReport: 7000,
            },
            call_not_pick_up: {
                numberOfLead: 7,
                projectReport: 7000,
            },
            not_interested: {
                numberOfLead: 7,
                projectReport: 7000,
            },
            work_assign_to_operation: {
                numberOfLead: 7,
                totalFeesAgreed: 1000,
                advanceRecd: 800,
                finalDue: 200,
            },
            work_complete: {
                numberOfLead: 7,
                totalFeesAgreed: 1000,
                advanceRecd: 800,
                finalDue: 200,
            },
        },
    ]);

    // DYNAMIC DATA
    const branchData = reportData || [];

    const onFilter = (event) => {
        setFilters(event.filters);
    };

    const onGlobalFilterChange = (e) => {

        const value = e.target.value;

        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);

        setGlobalFilterValue(value);
    };

    const loadMore = () => {
        console.log("Load More Clicked");
    };

     
    // COMMON BODY TEMPLATE
    const statusBodyTemplate2 = (rowData, field) => {

        const data = rowData[field];

        return (
            <div className="flex flex-column">
                <div>
                    <b>Lead:</b> {data?.numberOfLead}
                </div>

                <div>
                    <b>Total Fees Agreed:</b> ₹{data?.totalFeesAgreed}
                </div>

                <div>
                    <b>Advance Recd:</b> ₹{data?.advanceRecd}
                </div>

                <div>
                    <b>Final Due:</b> ₹{data?.finalDue}
                </div>
            </div>
        );
    };

    const statusBodyTemplate = (rowData, field) => {

        const data = rowData[field];

        return (
            <div className="flex flex-row justify-content-between">
                <div>
                    <b>Lead:</b> {data?.numberOfLead}
                </div>

                <div>
                    <b>Amount:</b> ₹{data?.loanAmount}
                </div>
            </div>
        );
    };

    return (

        <main id="main" className="main">

            <section className="section main-color">

                <div className="row">

                    <div className="col-lg-12">

                        <div className="card-main">

                            <div className="card-body">

                                {/* HEADER */}
                                <h5 className="card-title flex">

                                    <div
                                        className="mr-3 cursor-pointer"
                                        onClick={() => navigate("/masters")}
                                    >
                                        <i className="bi bi-arrow-left-circle-fill"></i>
                                    </div>

                                    Project Report And Cma Report

                                </h5>

                                {/* FILTERS */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: 5,
                                        marginBottom: 15,
                                    }}
                                >

                                    <div className="row w-full">

                                        <div className="col-md-4 mb-2">

                                            <InputText
                                                type="text"
                                                value={globalFilterValue}
                                                onChange={onGlobalFilterChange}
                                                placeholder="Keyword Search"
                                                style={{ width: "100%" }}
                                            />

                                        </div>

                                    </div>

                                </div>

                                {/* TABLE */}
                                <div className="card">

                                    <DataTable
                                        value={branchData}
                                        paginator
                                        rows={rows}
                                        filters={filters}
                                        onFilter={onFilter}
                                        globalFilterFields={[
                                            "telecallerName",
                                        ]}
                                        stripedRows
                                        responsiveLayout="scroll"
                                        className="p-datatable-gridlines"
                                        showGridlines
                                        resizableColumns
                                    >

                                        {/* SR NO */}
                                        <Column
                                            header="#"
                                            body={(data, options) =>
                                                options.rowIndex + 1
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                       
                                        {/* TELECALLER */}

                                         
                                        
                                        
                                        <Column
                                            header="Unattended Leads"
                                            body={(rowData) =>
                                                statusBodyTemplate(
                                                    rowData,
                                                    "unattended_leads"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            header="In Process"
                                            body={(rowData) =>
                                                statusBodyTemplate(
                                                    rowData,
                                                    "in_process"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* UNATTENDED */}
                                        <Column
                                            header="Call Not Pick Up"
                                            body={(rowData) =>
                                                statusBodyTemplate(
                                                    rowData,
                                                    "call_not_pick_up"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* IN PROCESS */}
                                        <Column
                                            header="Not Interested"
                                            body={(rowData) =>
                                                statusBodyTemplate(
                                                    rowData,
                                                    "not_interested"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* CALL NOT PICK */}
                                        <Column
                                            header="Work Assign To Operation"
                                            body={(rowData) =>
                                                statusBodyTemplate2(
                                                    rowData,
                                                    "work_assign_to_operation"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        {/* NOT INTERESTED */}
                                        <Column
                                            header="Work Complete"
                                            body={(rowData) =>
                                                statusBodyTemplate2(
                                                    rowData,
                                                    "work_complete"
                                                )
                                            }
                                            className="product-category table-design-without-btn"
                                        />

                                        
                                    </DataTable>

                                </div>

                                {/* LOAD MORE BUTTON */}
                                <div className="flex justify-content-center mt-4">

                                    <Button
                                        type="button"
                                        icon="pi pi-plus"
                                        label="Load More"
                                        onClick={loadMore}
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </main>
    );
}